import { useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";
import { useUsersContext } from "../../../context/usersContext";
import { useUserInfo } from "../../../context/user";
import AddUserModal from "../../Settings/components/team/component/AddUserModal";
import { useShareChat } from "../../../queries/chatActions";

const CloseIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const PencilIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
  </svg>
);

const ShareArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M21 11.5L13 4v4.5C7 9 3 12 3 19c2-3 5-4 10-4V19l8-7.5z" />
  </svg>
);

const LinkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 25 25" fill="none">
    <path d="M10.4166 13.5417C10.864 14.1398 11.4347 14.6346 12.0901 14.9927C12.7455 15.3508 13.4703 15.5637 14.2152 15.6171C14.9602 15.6704 15.7079 15.5629 16.4076 15.3019C17.1074 15.0409 17.7428 14.6324 18.2708 14.1042L21.3958 10.9792C22.3445 9.99691 22.8695 8.68127 22.8576 7.31566C22.8458 5.95006 22.298 4.64374 21.3324 3.67807C20.3667 2.71241 19.0604 2.16465 17.6948 2.15278C16.3292 2.14092 15.0135 2.66589 14.0312 3.61463L12.2395 5.39588M14.5833 11.4584C14.136 10.8603 13.5652 10.3655 12.9098 10.0074C12.2544 9.64932 11.5296 9.43638 10.7847 9.38303C10.0398 9.32968 9.29206 9.43716 8.59231 9.69819C7.89256 9.95922 7.25714 10.3677 6.72913 10.8959L3.60413 14.0209C2.65539 15.0032 2.13042 16.3188 2.14229 17.6844C2.15415 19.05 2.70191 20.3564 3.66758 21.322C4.63324 22.2877 5.93956 22.8354 7.30517 22.8473C8.67077 22.8592 9.98641 22.3342 10.9687 21.3855L12.75 19.6042" stroke="#1E1E1E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const UploadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 25 25" fill="none">
    <path d="M4.16675 12.5V20.8334C4.16675 21.3859 4.38624 21.9158 4.77694 22.3065C5.16764 22.6972 5.69755 22.9167 6.25008 22.9167H18.7501C19.3026 22.9167 19.8325 22.6972 20.2232 22.3065C20.6139 21.9158 20.8334 21.3859 20.8334 20.8334V12.5M8.33341 6.25004L12.5001 2.08337L16.6667 6.25004M12.5001 2.08337L12.5001 15.625" stroke="#1E1E1E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="13 13 25 25" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M34.3574 16.6329C32.0076 14.2913 28.8824 13.0012 25.5525 13C18.691 13 13.1068 18.5568 13.1045 25.3871C13.1033 27.5706 13.6768 29.7019 14.7661 31.5801L13 38L19.5989 36.2774C21.4169 37.2647 23.4641 37.7844 25.5472 37.785H25.5525C32.4128 37.785 37.9976 32.2276 38 25.3972C38.0012 22.0869 36.7078 18.975 34.3574 16.6335V16.6329ZM25.5525 35.6929H25.5483C23.6921 35.6924 21.8711 35.1957 20.2823 34.2578L19.9045 34.0345L15.9885 35.0568L17.0336 31.257L16.7877 30.8673C15.7521 29.2279 15.2048 27.333 15.206 25.3878C15.2084 19.7109 19.8495 15.092 25.5567 15.092C28.3201 15.0932 30.9177 16.1654 32.8712 18.1119C34.8247 20.0578 35.8997 22.6453 35.8985 25.3961C35.896 31.0735 31.2549 35.6924 25.5525 35.6924V35.6929ZM31.2274 27.9817C30.9165 27.8267 29.3874 27.0782 29.102 26.9749C28.8167 26.8715 28.6097 26.8199 28.4025 27.1299C28.1954 27.44 27.5992 28.1374 27.4177 28.3434C27.2363 28.5502 27.0548 28.5757 26.7438 28.4206C26.4329 28.2656 25.4308 27.9389 24.2424 26.8846C23.3179 26.0637 22.6935 25.0504 22.5122 24.7403C22.3307 24.4302 22.4931 24.2627 22.6482 24.1089C22.7878 23.9699 22.9592 23.7471 23.1149 23.5665C23.2708 23.386 23.3221 23.2565 23.4259 23.0504C23.5298 22.8436 23.4778 22.6631 23.4003 22.508C23.3226 22.353 22.7008 20.8294 22.4411 20.2099C22.1886 19.6064 21.932 19.6884 21.7416 19.6783C21.5601 19.6694 21.3531 19.6676 21.1453 19.6676C20.9376 19.6676 20.601 19.7448 20.3157 20.0549C20.0304 20.3649 19.227 21.1139 19.227 22.6369C19.227 24.1599 20.3414 25.6325 20.4972 25.8392C20.6529 26.0459 22.6906 29.1721 25.8103 30.5133C26.5523 30.8323 27.1318 31.023 27.5836 31.1655C28.3285 31.4013 29.0065 31.3681 29.5425 31.2885C30.14 31.1994 31.3826 30.5394 31.6417 29.8165C31.9007 29.0936 31.9007 28.4735 31.8231 28.3446C31.7456 28.2157 31.5378 28.1379 31.2269 27.9829L31.2274 27.9817Z" fill="#25D366" />
  </svg>
);

const MessengerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="12 12 25 25" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M24.5001 12C17.4585 12 12 17.1582 12 24.1251C12 27.7692 13.4934 30.9182 15.9256 33.0932C16.1297 33.2761 16.2532 33.532 16.2616 33.8061L16.3297 36.0295C16.3516 36.7389 17.0841 37.2001 17.7332 36.9139L20.2141 35.8186C20.4244 35.7258 20.6601 35.7086 20.8816 35.7695C22.0216 36.083 23.2351 36.2501 24.5001 36.2501C31.5417 36.2501 37.0002 31.092 37.0002 24.1251C37.0002 17.1582 31.5417 12 24.5001 12Z" fill="url(#paint0_radial_msg)" />
    <path fillRule="evenodd" clipRule="evenodd" d="M16.9938 27.671L20.6657 21.8454C21.2498 20.9185 22.5004 20.6879 23.377 21.345L26.2973 23.5354C26.5652 23.7363 26.9339 23.7354 27.2008 23.5329L31.1449 20.5394C31.6714 20.14 32.3586 20.77 32.0061 21.3291L28.3342 27.1548C27.7502 28.0813 26.4992 28.3123 25.623 27.6551L22.7023 25.4648C22.4345 25.2638 22.0658 25.2648 21.7989 25.4673L17.8548 28.4607C17.3282 28.8601 16.641 28.2301 16.9935 27.671H16.9938Z" fill="white" />
    <defs>
      <radialGradient id="paint0_radial_msg" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(16.875 36.8111) scale(27.2502 27.2502)">
        <stop stopColor="#0099FF" />
        <stop offset="0.61" stopColor="#A033FF" />
        <stop offset="0.93" stopColor="#FF5280" />
        <stop offset="1" stopColor="#FF7061" />
      </radialGradient>
    </defs>
  </svg>
);

const XIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="#1E1E1E">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 28 25" fill="none">
    <path d="M25.7733 20.6018C25.3755 20.6056 24.9954 20.7668 24.7161 21.0501C24.4368 21.3335 24.2811 21.7159 24.2831 22.1137C24.285 22.5115 24.4443 22.8924 24.7263 23.173C25.0083 23.4536 25.3899 23.6111 25.7877 23.6111C26.1856 23.6111 26.5672 23.4536 26.8492 23.173C27.1311 22.8924 27.2905 22.5115 27.2924 22.1137C27.2943 21.7159 27.1386 21.3335 26.8594 21.0501C26.5801 20.7668 26.2 20.6056 25.8022 20.6018H25.7733ZM25.7733 23.4389C25.5123 23.4432 25.256 23.3701 25.0366 23.2287C24.8173 23.0874 24.6447 22.8842 24.5409 22.6448C24.437 22.4054 24.4065 22.1406 24.4531 21.8838C24.4998 21.627 24.6215 21.3899 24.8029 21.2023C24.9844 21.0147 25.2173 20.8852 25.4724 20.83C25.7274 20.7749 25.9931 20.7966 26.2359 20.8924C26.4786 20.9882 26.6874 21.1539 26.836 21.3684C26.9846 21.583 27.0662 21.8367 27.0705 22.0976V22.1198C27.0779 22.4621 26.9489 22.7932 26.7121 23.0405C26.4753 23.2877 26.1499 23.4308 25.8077 23.4382H25.7736M19.9973 20.1907H16.7277V15.0704C16.7277 13.8494 16.7059 12.2776 15.0271 12.2776C13.3242 12.2776 13.0637 13.6079 13.0637 14.9815V20.1904H9.79405V9.66084H12.9329V11.0998H12.9768C13.2909 10.5627 13.7449 10.1209 14.2902 9.82137C14.8356 9.52185 15.452 9.37585 16.0738 9.39893C19.3876 9.39893 19.9986 11.5787 19.9986 14.4144L19.9973 20.1907ZM6.10484 8.22153C5.72957 8.2216 5.3627 8.11039 5.05064 7.90195C4.73858 7.69352 4.49533 7.39723 4.35166 7.05055C4.20799 6.70387 4.17035 6.32238 4.2435 5.9543C4.31664 5.58623 4.49729 5.24811 4.76259 4.98271C5.0279 4.71731 5.36595 4.53654 5.734 4.46326C6.10205 4.38998 6.48356 4.42749 6.83029 4.57104C7.17702 4.71458 7.47339 4.95772 7.68194 5.26971C7.89048 5.5817 8.00182 5.94852 8.00189 6.32379C8.00194 6.57296 7.95291 6.8197 7.8576 7.04992C7.76229 7.28014 7.62256 7.48934 7.4464 7.66556C7.27025 7.84178 7.0611 7.98158 6.83091 8.07697C6.60073 8.17237 6.35401 8.22149 6.10484 8.22153ZM7.73964 20.1907H4.46662V9.66084H7.73964V20.1907ZM21.6273 1.39042H2.82365C2.39686 1.3856 1.98561 1.55042 1.68028 1.84866C1.37495 2.14691 1.20052 2.55416 1.19531 2.98095V21.8626C1.20034 22.2896 1.37467 22.6972 1.67999 22.9957C1.9853 23.2943 2.39664 23.4594 2.82365 23.4549H21.6273C22.0552 23.4602 22.4677 23.2956 22.7742 22.997C23.0807 22.6985 23.2562 22.2905 23.2621 21.8626V2.97959C23.256 2.55196 23.0804 2.14423 22.7739 1.846C22.4673 1.54777 22.055 1.38342 21.6273 1.38906M26.012 22.2019C26.068 22.2024 26.1235 22.1915 26.1751 22.1697C26.2267 22.1479 26.2732 22.1157 26.3119 22.0752C26.3505 22.0347 26.3804 21.9867 26.3997 21.9341C26.419 21.8815 26.4273 21.8256 26.4241 21.7697C26.4241 21.4631 26.2392 21.3167 25.8598 21.3167H25.2467V22.9215H25.4773V22.222H25.7607L25.7671 22.2305L26.2068 22.9215H26.4534L25.9803 22.2063L26.012 22.2019ZM25.7453 22.0411H25.478V21.4986H25.8169C25.9919 21.4986 26.1915 21.5272 26.1915 21.7564C26.1915 22.02 25.9895 22.0411 25.744 22.0411" fill="#2867B2" />
  </svg>
);

const SocialButton = ({ label, onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    className="flex flex-col items-center gap-1.5 group"
  >
    <span className="w-12 h-12 rounded-full flex items-center justify-center bg-card border border-border group-hover:opacity-90">
      {children}
    </span>
    <span className="text-[11px] text-muted-foreground">{label}</span>
  </button>
);

const ShareChatModal = ({
  isOpen,
  onClose,
  chatTitle,
  contact,
  id,
  shareType = "chat",
  resourceTitle,
  onSuccess,
}) => {
  const { locationUsers, getLocationUsers, products, requestLocationUsers } = useUsersContext();
  const [user, , , , userActiveLocation] = useUserInfo();

  useEffect(() => {
    if (isOpen) requestLocationUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);
  const activeplans = products?.filter?.((item) => item.activePlan)?.[0];
  const [showAddTeamMember, setShowAddTeamMember] = useState(false);
  const isTaskShare = shareType === "task";
  const shareTargetLabel = isTaskShare ? "task" : "chat";
  const modalTitle = resourceTitle || chatTitle || shareTargetLabel;

  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [message, setMessage] = useState(
    "This task removed work for me. You can run it yourself if useful.",
  );
  const { mutateAsync: shareChat, isPending: processing } = useShareChat();

  const existingUsers = useMemo(() => {

    if (isTaskShare) {
      return Array.isArray(contact?.shared_with) ? contact.shared_with : [];
    }
    if (Array.isArray(contact)) return contact;
    if (Array.isArray(contact?.userId)) return contact.userId;
    if (contact?.userId) return [contact.userId];
    return [];
  }, [contact, isTaskShare]);

  useEffect(() => {
    if (!isOpen) return;
    setSelectedUserIds(
      existingUsers
        .filter((user) => user?.type !== "author")
        .map((user) => user?.id || user?._id)
        .filter(Boolean),
    );
  }, [isOpen, existingUsers]);


  const alreadySharedUserIds = useMemo(() => {
    if (!isTaskShare) return new Set();
    return new Set(
      existingUsers.map((user) => user?.id || user?._id).filter(Boolean),
    );
  }, [existingUsers, isTaskShare]);

  const toggleUser = (userId) => {
    if (alreadySharedUserIds.has(userId)) return;
    setSelectedUserIds((current) =>
      current.includes(userId)
        ? current.filter((existingId) => existingId !== userId)
        : [...current, userId],
    );
  };


  const hasNewSelection = selectedUserIds.some(
    (userId) => !alreadySharedUserIds.has(userId),
  );

  const handleClose = () => {
    if (processing) return;
    onClose?.();
  };

  const handleShareSubmit = async () => {
    if (processing) return;

    // Already-shared recipients are pre-checked for visibility but must not
    // count as a fresh share — only newly-picked teammates get a copy.
    const idsToShare = selectedUserIds.filter(
      (userId) => !alreadySharedUserIds.has(userId),
    );

    if (!idsToShare.length) {
      toast.error(
        isTaskShare
          ? "Select at least one teammate who doesn't already have a copy."
          : "Select at least one teammate to share with.",
      );
      return;
    }

    const author = existingUsers.find((user) => user?.type === "author");
    const sharedUsers = idsToShare
      .map((userId) => {
        const found = locationUsers?.find((user) => user?._id === userId);
        if (!found) return null;
        return {
          id: found._id,
          username: found.userName,
          type: "shared",
          permission: "use-only",
        };
      })
      .filter(Boolean);

    const nextUsers = author ? [author, ...sharedUsers] : sharedUsers;

    // Task shares duplicate the Task per recipient on the backend — they only
    // need the recipient list, never the original task's own userId array.
    const payload = isTaskShare
      ? { _id: contact?._id, recipients: sharedUsers }
      : { chatId: id, userId: nextUsers };

    try {
      await shareChat({ shareType, payload });
      await onSuccess?.();
      toast.success(
        `${isTaskShare ? "Task" : "Chat"} shared with ${sharedUsers.length} ${sharedUsers.length === 1 ? "person" : "people"
        }`,
      );
      onClose?.();
    } catch (error) {
      console.error(`Error sharing ${shareTargetLabel}:`, error);
      toast.error(`Couldn't share the ${shareTargetLabel}.`);
    }
  };

  const shareUrl =
    typeof window !== "undefined" ? window.location.href : "";
  const shareText = `${modalTitle} — ${message}`;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Link copied");
    } catch {
      toast.error("Couldn't copy link");
    }
  };

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: modalTitle, text: message, url: shareUrl });
      } catch {
        /* user cancelled */
      }
    } else {
      handleCopyLink();
    }
  };

  const openExternal = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
          onClick={handleClose}
        >
          <div
            className="bg-card rounded-lg shadow-xl w-[480px] max-w-[92vw] max-h-[92vh] overflow-y-auto p-6"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="flex items-start justify-between gap-4">
              <h3 className="text-[16px] font-semibold text-foreground truncate">
                Share '{modalTitle}'
              </h3>
              <button
                type="button"
                aria-label="Close"
                onClick={handleClose}
                className="text-muted-foreground hover:text-foreground shrink-0"
              >
                <CloseIcon />
              </button>
            </div>

            <p className="text-[13px] !text-foreground mt-2 leading-snug">
              Let someone else run this {shareTargetLabel} on their own work.
              Nothing runs until they choose to.
            </p>

            <div className="mt-4 bg-muted rounded-md p-3">
              <div className="text-[12px] text-muted-foreground">What's shared</div>
              <div className="text-[13px] text-foreground mt-0.5">
                {isTaskShare
                  ? "Title and description, copied to their own Task. They set their own schedule, output and webhook."
                  : "Chat content and read-only context"}
              </div>
            </div>

            <div className="mt-5">
              <div className="text-[13px] text-muted-foreground mb-2">
                Who should be able to run this {shareTargetLabel}?
              </div>
              <div className="space-y-2">
                {(locationUsers || []).map((user) => {
                  const userId = user?._id;
                  const alreadyShared = alreadySharedUserIds.has(userId);
                  const checked = alreadyShared || selectedUserIds.includes(userId);
                  return (
                    <label
                      key={userId}
                      className={`flex items-center gap-3 ${alreadyShared ? "cursor-not-allowed opacity-60" : "cursor-pointer"
                        }`}
                    >
                      <input
                        type="checkbox"
                        checked={checked}
                        disabled={alreadyShared}
                        onChange={() => toggleUser(userId)}
                        className="w-4 h-4 accent-[#2563eb]"
                      />
                      <span className="text-[14px] text-foreground capitalize">
                        {user?.userName}
                      </span>
                      {alreadyShared && (
                        <span className="text-[11px] italic text-muted-foreground">
                          Already shared
                        </span>
                      )}
                    </label>
                  );
                })}
                {!locationUsers?.length && (
                  <p className="text-[13px] text-muted-foreground">
                    No teammates available.
                  </p>
                )}
              </div>
              <button
                type="button"
                onClick={() => {
                  setShowAddTeamMember(true);
                  onClose?.();
                }}
                className="text-[13px] text-[#5C6CFF] mt-3 hover:underline"
              >
                Add Team Member
              </button>
            </div>

            <div className="mt-5">
              <div className="text-[13px] text-muted-foreground mb-2">
                Message (optional)
              </div>
              <div className="relative">
                <textarea
                  value={message}
                  onChange={(event) => setMessage(event.target.value)}
                  rows={3}
                  className="w-full border border-border rounded-md p-3 pr-9 text-[13px] !text-muted-foreground outline-none  resize-none"
                />
                <span className="absolute right-3 bottom-3 text-muted-foreground pointer-events-none">
                  <PencilIcon />
                </span>
              </div>
            </div>

            <button
              type="button"
              onClick={handleShareSubmit}
              disabled={processing || !hasNewSelection}
              className={`mt-5 w-full h-11 rounded-md bg-primary  text-primary-foreground font-medium flex items-center justify-center gap-2 ${processing || !hasNewSelection ? "opacity-60 cursor-not-allowed" : ""
                }`}
            >
              {processing ? (
                <div className="spinner" />
              ) : (
                <ShareArrowIcon />
              )}
              Share {isTaskShare ? "Task" : "Chat"}
            </button>

            <div className="mt-5 flex items-center justify-between gap-2">
              <SocialButton label="Copy link" onClick={handleCopyLink}>
                <LinkIcon />
              </SocialButton>
              <SocialButton label="Share to..." onClick={handleNativeShare}>
                <UploadIcon />
              </SocialButton>
              <SocialButton
                label="WhatsApp"
                onClick={() =>
                  openExternal(
                    `https://wa.me/?text=${encodeURIComponent(`${shareText} ${shareUrl}`)}`,
                  )
                }
              >
                <WhatsAppIcon />
              </SocialButton>
              <SocialButton
                label="Messenger"
                onClick={() =>
                  openExternal(
                    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
                  )
                }
              >
                <MessengerIcon />
              </SocialButton>
              <SocialButton
                label="X"
                onClick={() =>
                  openExternal(
                    `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`,
                  )
                }
              >
                <XIcon />
              </SocialButton>
              <SocialButton
                label="LinkedIn"
                onClick={() =>
                  openExternal(
                    `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
                  )
                }
              >
                <LinkedInIcon />
              </SocialButton>
            </div>
          </div>
        </div>
      )}

      <AddUserModal
        isModalOpen={showAddTeamMember}
        justCloseIt={() => setShowAddTeamMember(false)}
        getLocationUsers={getLocationUsers}
        user={user}
        userActiveLocation={userActiveLocation}
        activeplans={activeplans}
        locationUsers={locationUsers}
        setActiveTab={() => { }}
        setPricingHeading={() => { }}
      />
    </>
  );
};

export default ShareChatModal;
